import styled from '@emotion/styled'
import {
    Box,
    Card,
    CardContent,
    Container,
    DialogContent,
    Drawer,
    FormControl,
    Stack,
    Tabs,
    TextField,
    Typography,
} from '@mui/material'
import { Link } from 'react-router-dom'
import { getPxAsRem } from 'shared/utils'

export const StyledContainer = styled(Container)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: ${getPxAsRem(6, 24)};
`

export const Header = styled(Container)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${getPxAsRem(16)};
    background-color: ${({ theme }) => theme.palette.greyscale.white};
`

export const DesktopHeader = styled(Container)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${getPxAsRem(16)};
    background-color: ${({ theme }) => theme.palette.greyscale.white};
`

export const StyledHeader = styled(Container)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${getPxAsRem(24)};
    background-color: ${({ theme }) => theme.palette.greyscale.white};
    padding: ${getPxAsRem(24, 0)};
`

export const WebLink = styled.a`
    text-decoration: none;
    color: ${({ theme }) => theme.palette.info.main};
    &:hover {
        text-decoration: underline;
    }
`

export const StyledDrawer = styled(Drawer)`
    .MuiDrawer-paper {
        display: flex;
        flex-direction: column;
        padding: ${getPxAsRem(24)};
        width: ${getPxAsRem(515)};
        height: 100%;
    }
`

export const ContactHeader = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${getPxAsRem(16)};
`

export const StyledTabs = styled(Tabs)`
    margin-bottom: ${getPxAsRem(16)};
`

export const ContactSection = styled(Box)`
    margin-bottom: ${getPxAsRem(24)};
`

export const ContentWrapper = styled(Box)`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
`

export const InfoRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${getPxAsRem(2)};
`

export const EditHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const StyledDialogContent = styled(DialogContent)`
    padding: ${getPxAsRem(32)};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${getPxAsRem(24)};
    min-width: ${getPxAsRem(300)};
    min-height: ${getPxAsRem(300)};
`

export const DialogButtonContainer = styled(FormControl)`
    display: flex;
    gap: ${getPxAsRem(8)};
    flex-direction: row;
`

export const CompanyLink = styled(Link)`
    text-decoration: none;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`

export const StyledCard = styled(Card)`
    display: flex;
    flex-direction: column;
    padding: ${getPxAsRem(16)};
    height: ${getPxAsRem(500)};
    overflow: auto;
    box-shadow: 0px 1px 3px rgba(231, 34, 34, 0.2);
    border-radius: ${getPxAsRem(8)};
`

export const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: getPxAsRem(8),
}))

export const StyledTypography = styled(Typography)(({ theme }) => ({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    WebkitLineClamp: 3,
    textOverflow: 'ellipsis',
}))

export const CompanyCardContent = styled(CardContent)`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const MobileClientCardContent = styled(CardContent)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: ${getPxAsRem(30)};
`

export const ClientDetails = styled(Typography)`
    text-align: left;
    font-size: ${getPxAsRem(14)};
`

export const DetailStack = styled(Stack)`
    text-align: left;
`

export const StyledRichTextEditor = styled('div')`
    .ProseMirror {
        height: ${getPxAsRem(476)};
        overflow-y: auto;
    }
`

export const NoWrapBox = styled(Box)`
    display: inline-flex;
    flex-direction: column;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`

export const StyledStack = styled(Stack)`
    width: 100%;
`

export const CompanyInfoBox = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${getPxAsRem(16)};
    width: 40%;
`

export const DetailBox = styled(Box)`
    width: 20%;
`

export const IndustriesBox = styled(Box)`
    display: flex;
    gap: ${getPxAsRem(8)};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const IndustryItemBox = styled(Box)<{ isLast: boolean }>`
    display: flex;
    align-items: center;
    overflow: ${(props) => (props.isLast ? 'hidden' : 'visible')};
    text-overflow: ${(props) => (props.isLast ? 'ellipsis' : 'clip')};
    white-space: nowrap;
`

export const HeaderContainer = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${getPxAsRem(16)};
`

export const MobileHeaderContainer = styled(Box)`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: ${getPxAsRem(16)};
    flex-direction: column;
`
export const SearchContainer = styled(Box)`
    display: flex;
    align-items: center;
    gap: ${getPxAsRem(8)};
`

export const MobileSearchContainer = styled(Box)`
    display: flex;
    gap: ${getPxAsRem(12)};
`

export const StyledTextField = styled(TextField)`
    & .MuiInputBase-root {
        padding-right: ${getPxAsRem(8)};
    }
`
